<section *ngIf="rewards.length"
         class="reward-items">
    
    <h2 class="reward-items__title">{{ 'my_profile.my_rewards' | translate }}</h2>

    <ul class="reward-items__list">
        <li *ngFor="let r of rewards"
            class="reward-items__card"
            [class.reward-items__card--locked]="r.locked">
            <img class="reward-items__card-image"
                 [src]="r.url"
                 [alt]="r.title">
            <div class="reward-items__card-content"
                 [attr.aria-hidden]="r.locked">
                <h3 class="reward-items__card-title">{{ r.title }}</h3>
                <p class="reward-items__card-label">{{ r.label }}</p>
            </div>
            <div *ngIf="r.locked"
                 class="reward-items__locked-card-content">
                <mat-icon class="reward-items__locked-card-icon"
                          svgIcon="lock">
                </mat-icon>
                <p class="reward-items__locked-card-label">{{ r.lockedLabel }}</p>
            </div>
        </li>
    </ul>

</section>